import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Stack from "react-bootstrap/Stack";

/**
 * Vertical content panels on light-gray background.
 * When section.imageUrl is set, renders a two-column layout:
 * stack items on the left, image on the right.
 */
export default function SectionStack({ section }) {
  if (!section?.items?.length) return null;
  const { id, kicker, title, items, imageUrl, imageAlt } = section;

  const content = (
    <>
      {kicker && <p className="pmp-kicker mb-2">{kicker}</p>}
      <h2 className="h3 fw-bold mb-4">{title}</h2>
      <Stack gap={3}>
        {items.map((item, i) => (
          <div key={`${item.title}-${i}`} className="pmp-stack-item">
            <h3 className="h5 fw-bold mb-2">{item.title}</h3>
            <p className="text-secondary mb-0">{item.body}</p>
          </div>
        ))}
      </Stack>
    </>
  );

  return (
    <section className="pmp-stack-section" id={id}>
      <Container>
        {imageUrl ? (
          <>
            {kicker && <p className="pmp-kicker mb-2">{kicker}</p>}
            <h2 className="h3 fw-bold mb-4">{title}</h2>
            {/* align-items-stretch + a flex image column makes the map/image match
                the height of the stack of items beside it (equal-height columns). */}
            <Row className="align-items-stretch g-5">
              <Col md={6}>
                <Stack gap={3}>
                  {items.map((item, i) => (
                    <div key={`${item.title}-${i}`} className="pmp-stack-item">
                      <h3 className="h5 fw-bold mb-2">{item.title}</h3>
                      <p className="text-secondary mb-0">{item.body}</p>
                    </div>
                  ))}
                </Stack>
              </Col>
              <Col md={6} className="d-flex">
                <div className="pmp-stack-side-image">
                  <img src={imageUrl} alt={imageAlt ?? ""} />
                </div>
              </Col>
            </Row>
          </>
        ) : (
          content
        )}
      </Container>
    </section>
  );
}
